<template>
    <section v-html="article_html"></section>
</template>
<script>
export default{
    name: "article-html",
    props: {
        article_html: String
    }
}</script>
